import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  viewTrianingPlanButton: {
    textDecoration: "underline",
    textTransform: "none",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000",
    padding: 0,
    display: "flex",
    justifyContent: "flex-start",
  },
}));

export default useStyles;
